/* RMS para birimi gostergesi — Convercy yerine, ucretsiz, tema ici.
   Magaza para birimi TL'dir ve oyle kalir. Bu script SADECE GOSTERIM icin
   EUR/USD karsiligini yazar. Odeme her zaman TL alinir (iyzico).
   shop.money_format'a DOKUNMAZ — o yuzden Globo filtresi, facet fiyat
   araligi, hacim fiyatlandirma ve meta etiketler etkilenmez. */
(function () {
  'use strict';
  if (window.RMS_FX) return;

  var CUR = {
    TRY: { sym: '₺', label: 'TL' },
    EUR: { sym: '€', label: 'EUR' },
    USD: { sym: '$', label: 'USD' }
  };
  var ORDER = ['TRY', 'EUR', 'USD'];
  var CKEY = 'rms-cur-v1';
  var FKEY = 'rms-fx-v1';
  var TTL = 12 * 3600 * 1000;
  var FALLBACK = { EUR: 0.01805, USD: 0.020884 };   /* 17.08.2026 */
  var API = 'https://open.er-api.com/v6/latest/TRY';

  var MONEY = /(\d{1,3}(?:\.\d{3})*,\d{2})\s*(?:TL|TRY)\b/g;

  var S = window.RMS_FX = {
    cur: 'TRY', rates: null, kaynak: null, sarili: 0, yazilan: 0, hazir: false
  };

  var busy = false;

  function ls(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); }
    catch (e) { return null; }
  }

  function loc() {
    var l = (document.documentElement.getAttribute('lang') || 'tr').toLowerCase();
    return l.indexOf('de') === 0 ? 'de-DE' : (l.indexOf('tr') === 0 ? 'tr-TR' : 'en-US');
  }

  function varsayilan() {
    var kayit = ls(CKEY);
    if (kayit && CUR[kayit]) return kayit;
    var c = (window.Shopify && Shopify.country) || 'TR';
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('de') === 0) return 'EUR';
    if (l.indexOf('tr') === 0 || c === 'TR') return 'TRY';
    var avro = ['AT','BE','DE','ES','FI','FR','IE','IT','NL','PT','GR','LU','SK','SI','EE','LV','LT','CY','MT','HR'];
    if (avro.indexOf(c) > -1) return 'EUR';
    return 'USD';
  }

  function kurAl(cb) {
    var ham = ls(FKEY);
    if (ham) {
      try {
        var o = JSON.parse(ham);
        if (o && o.ts && (Date.now() - o.ts) < TTL && o.r && o.r.EUR && o.r.USD) {
          S.rates = o.r; S.kaynak = 'onbellek'; return cb();
        }
      } catch (e) {}
    }
    var bitti = false;
    var zaman = setTimeout(function () {
      if (bitti) return; bitti = true;
      S.rates = FALLBACK; S.kaynak = 'yedek-zamanasimi'; cb();
    }, 3500);
    try {
      fetch(API, { mode: 'cors' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (bitti) return; bitti = true; clearTimeout(zaman);
          if (j && j.rates && j.rates.EUR && j.rates.USD) {
            S.rates = { EUR: j.rates.EUR, USD: j.rates.USD };
            S.kaynak = 'canli';
            ls(FKEY, JSON.stringify({ ts: Date.now(), r: S.rates }));
          } else { S.rates = FALLBACK; S.kaynak = 'yedek-bos'; }
          cb();
        })
        .catch(function () {
          if (bitti) return; bitti = true; clearTimeout(zaman);
          S.rates = FALLBACK; S.kaynak = 'yedek-hata'; cb();
        });
    } catch (e) {
      if (!bitti) { bitti = true; clearTimeout(zaman); S.rates = FALLBACK; S.kaynak = 'yedek-istisna'; cb(); }
    }
  }

  function sayiyaCevir(s) { return parseFloat(s.replace(/\./g, '').replace(',', '.')) || 0; }

  function bicimle(deger, kod) {
    try {
      return new Intl.NumberFormat(loc(), {
        style: 'currency', currency: kod, maximumFractionDigits: 2, minimumFractionDigits: 2
      }).format(deger);
    } catch (e) {
      return CUR[kod].sym + deger.toFixed(2);
    }
  }

  /* --- fiyat metinlerini sar --- */
  function dugumSar(node) {
    var txt = node.nodeValue;
    MONEY.lastIndex = 0;
    if (!MONEY.test(txt)) return;
    MONEY.lastIndex = 0;
    var frag = document.createDocumentFragment(), son = 0, m;
    while ((m = MONEY.exec(txt))) {
      if (m.index > son) frag.appendChild(document.createTextNode(txt.slice(son, m.index)));
      var sp = document.createElement('span');
      sp.className = 'rms-fx';
      sp.setAttribute('data-tl', sayiyaCevir(m[1]));
      sp.setAttribute('data-ham', m[0]);
      sp.textContent = m[0];
      frag.appendChild(sp);
      son = m.index + m[0].length;
      S.sarili++;
    }
    if (son < txt.length) frag.appendChild(document.createTextNode(txt.slice(son)));
    node.parentNode.replaceChild(frag, node);
  }

  function tara(kok) {
    if (!kok || !kok.querySelectorAll) return;
    var w = document.createTreeWalker(kok, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var v = n.nodeValue;
        if (!v || (v.indexOf('TL') < 0 && v.indexOf('TRY') < 0)) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.tagName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEXTAREA' || t === 'OPTION' || t === 'TITLE') return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains('rms-fx')) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('.rms-fx-menu, .product-facet__filter-list, price-range, .price-range')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var liste = [], n;
    while ((n = w.nextNode())) liste.push(n);
    for (var i = 0; i < liste.length; i++) dugumSar(liste[i]);
  }

  function yaz() {
    var l = document.querySelectorAll('.rms-fx');
    S.yazilan = l.length;
    for (var i = 0; i < l.length; i++) {
      var el = l[i];
      if (S.cur === 'TRY') { el.textContent = el.getAttribute('data-ham'); }
      else {
        var tl = parseFloat(el.getAttribute('data-tl')) || 0;
        el.textContent = bicimle(tl * (S.rates[S.cur] || FALLBACK[S.cur]), S.cur);
      }
    }
    uyariGuncelle();
  }

  function uyariGuncelle() {
    var t = metin('not');
    var hedefler = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < hedefler.length; i++) {
      var h = hedefler[i];
      var kap = h.parentElement;
      if (!kap) continue;
      var u = kap.querySelector(':scope > .rms-fx-uyari');
      if (S.cur === 'TRY') { if (u) u.parentNode.removeChild(u); continue; }
      if (!u) {
        u = document.createElement('div');
        u.className = 'rms-fx-uyari';
        u.textContent = t;
        kap.insertBefore(u, h);
      } else if (u.textContent !== t) {
        u.textContent = t;
      }
    }
  }

  function fiyatNotu() {
    var t = metin('fnot');
    var kap = document.querySelectorAll('price-range, .price-range');
    for (var i = 0; i < kap.length; i++) {
      var k = kap[i];
      var u = k.querySelector(':scope > .rms-fx-fnot');
      if (S.cur === 'TRY') { if (u) u.parentNode.removeChild(u); continue; }
      if (!u) {
        u = document.createElement('div');
        u.className = 'rms-fx-fnot';
        u.textContent = t;
        k.appendChild(u);
      } else if (u.textContent !== t) {
        u.textContent = t;
      }
    }
  }

  function uygula(kok) {
    busy = true;
    try { tara(kok || document.body); yaz(); dugumGuncelle(); } finally {
      setTimeout(function () { busy = false; }, 0);
    }
  }

  /* --- header dugmesi --- */
  var CSS = '.rms-fx-wrap{position:relative;display:inline-flex;align-items:center;margin-right:1rem}'
    + '.rms-fx-btn{background:none;border:0;padding:0;cursor:pointer;font:inherit;color:inherit;display:inline-flex;align-items:center;gap:.3em;line-height:1}'
    + '.rms-fx-menu{position:absolute;top:100%;right:0;margin-top:.6rem;background:#fff;color:#111;border:1px solid rgba(0,0,0,.12);border-radius:.4rem;box-shadow:0 6px 24px rgba(0,0,0,.14);min-width:190px;padding:.4rem 0;z-index:2147483000;display:none}'
    + '.rms-fx-menu[data-acik="1"]{display:block}'
    + '.rms-fx-menu button{display:block;width:100%;text-align:left;background:none;border:0;padding:.6rem 1rem;cursor:pointer;font:inherit;color:#111;white-space:nowrap}'
    + '.rms-fx-menu button:hover{background:rgba(0,0,0,.05)}'
    + '.rms-fx-menu button[aria-current="true"]{font-weight:600}'
    + '.rms-fx-not{padding:.5rem 1rem;font-size:11px;line-height:1.35;color:#666;border-top:1px solid rgba(0,0,0,.08);margin-top:.3rem;white-space:normal}'
    + '.rms-fx-uyari{font-size:12px;line-height:1.4;color:#666;margin:0 0 .7rem;text-align:center}'
    + '@media screen and (max-width:999px){.rms-fx-wrap.rms-fx--d{display:none !important}}'
    + '@media screen and (min-width:1000px){.rms-fx-wrap.rms-fx--m{display:none !important}}'
    + '.rms-fx-fnot{font-size:11px;line-height:1.35;color:#777;margin-top:.5rem}';

  function metin(k) {
    var l = (document.documentElement.getAttribute('lang') || 'tr').toLowerCase();
    var T = {
      tr: { not: 'Fiyatlar yaklaşıktır. Ödeme Türk Lirası (TL) olarak alınır.', bas: 'Para birimi', fnot: 'Fiyat filtresi TL üzerinden çalışır.' },
      de: { not: 'Preise sind Richtwerte. Die Zahlung erfolgt in Türkischer Lira (TRY).', bas: 'Währung', fnot: 'Der Preisfilter arbeitet in TRY.' },
      en: { not: 'Prices are approximate. You are charged in Turkish Lira (TRY).', bas: 'Currency', fnot: 'The price filter works in TRY.' }
    };
    var d = l.indexOf('de') === 0 ? T.de : (l.indexOf('tr') === 0 ? T.tr : T.en);
    return d[k];
  }

  function dugumGuncelle() {
    var b = document.querySelectorAll('.rms-fx-btn');
    for (var i = 0; i < b.length; i++) {
      b[i].firstChild.nodeValue = CUR[S.cur].sym + ' ' + CUR[S.cur].label + ' ';
    }
    var o = document.querySelectorAll('.rms-fx-menu button[data-cur]');
    for (var j = 0; j < o.length; j++) {
      o[j].setAttribute('aria-current', o[j].getAttribute('data-cur') === S.cur ? 'true' : 'false');
    }
  }

  function kur(hedef, sinif) {
    if (!hedef || hedef.querySelector('.rms-fx-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'rms-fx-wrap ' + (sinif || '') + (sinif === 'rms-fx--d' ? ' hidden-pocket' : '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rms-fx-btn ' + (sinif === 'rms-fx--m' ? 'text--xsmall tap-area' : 'text--small');
    btn.setAttribute('aria-label', metin('bas'));
    btn.appendChild(document.createTextNode(CUR[S.cur].sym + ' ' + CUR[S.cur].label + ' '));
    var ok = document.createElement('span');
    ok.textContent = '▾';
    ok.style.fontSize = '.8em';
    btn.appendChild(ok);
    var menu = document.createElement('div');
    menu.className = 'rms-fx-menu';
    ORDER.forEach(function (k) {
      var o = document.createElement('button');
      o.type = 'button';
      o.setAttribute('data-cur', k);
      o.textContent = CUR[k].sym + '  ' + CUR[k].label + (k === 'TRY' ? '  —  Türk Lirası' : '');
      o.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        S.cur = k; ls(CKEY, k);
        menu.setAttribute('data-acik', '0');
        busy = true; yaz(); dugumGuncelle();
        setTimeout(function () { busy = false; }, 0);
      });
      menu.appendChild(o);
    });
    var not = document.createElement('div');
    not.className = 'rms-fx-not';
    not.textContent = metin('not');
    menu.appendChild(not);
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var a = menu.getAttribute('data-acik') === '1';
      document.querySelectorAll('.rms-fx-menu').forEach(function (m) { m.setAttribute('data-acik', '0'); });
      menu.setAttribute('data-acik', a ? '0' : '1');
    });
    wrap.appendChild(btn); wrap.appendChild(menu);
    hedef.insertBefore(wrap, hedef.firstChild);
  }

  function kurHepsi() {
    var d = document.getElementById('header-localization-form');
    if (d && d.parentElement) kur(d.parentElement, 'rms-fx--d');
    var m = document.getElementById('header-sidebar-localization-form');
    if (m && m.parentElement) kur(m.parentElement, 'rms-fx--m');
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.rms-fx-menu').forEach(function (m) { m.setAttribute('data-acik', '0'); });
  });

  function basla() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    S.cur = varsayilan();
    kurAl(function () {
      S.hazir = true;
      kurHepsi();
      uygula(document.body);
      var bekle = null;
      var mo = new MutationObserver(function (kayitlar) {
        if (busy) return;
        var var_ = false;
        for (var i = 0; i < kayitlar.length; i++) {
          if (kayitlar[i].addedNodes && kayitlar[i].addedNodes.length) { var_ = true; break; }
        }
        if (!var_) return;
        clearTimeout(bekle);
        bekle = setTimeout(function () { kurHepsi(); uygula(document.body); }, 150);
      });
      mo.observe(document.body, { childList: true, subtree: true });
      S.gozlemci = mo;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
